import React from 'react'
import { Link, graphql } from 'gatsby'
import Layout from '../components/Layout'
import SEO from '../components/seo'
import BG from '../images/awards-bg.jpg'

import moment from 'moment'

const NavLink = props => {
	if (!props.test) {
		return <Link to={props.url}>{props.text}</Link>
	} else {
		return <span>{props.text}</span>
	}
}
class AllNews extends React.Component {
	render() {
		const { data } = this.props
		const siteTitle = data.site.siteMetadata.title
		const { group, index, first, last } = this.props.pageContext
		const previousUrl = index - 1 === 1 ? '/' : (index - 1).toString()
		const nextUrl = (index + 1).toString()
		const sidelist = this.props.data.allSanityNews.edges
		// console.log(group)
		// console.log(this.props)

		return (
			<Layout location={this.props.location} title={siteTitle}>
				<SEO
					title="All News"
					keywords={[`blog`, `gatsby`, `javascript`, `react`]}
				/>
				<div
					id="sliderhead"
					className="blog-header blogheadpost"
					style={{
						background: `url(${BG}) 50% 13px fixed rgb(34, 34, 34`,
						position: 'relative',
					}}
				>
					<div className="container">
						<div className="text-det">
							<h5 className="related-title">Latest News</h5>
						</div>
					</div>
				</div>
				<div id="list-allblog" className="main-container">
					<div className="container">
						<div className="row">
							<div className="col-md-8 left-list">
								<div id="list-blog-all">
									{group.map(nws => (
										<div className="news-items" key={nws.node.id}>
											<div className="lead-sec">
												<div className="lead-image">
													<img
														src={
															nws &&
															nws.node &&
															nws.node.mainImage &&
															nws.node.mainImage.asset &&
															nws.node.mainImage.asset.fluid &&
															nws.node.mainImage.asset.fluid.src
														}
														alt={nws.node.title}
														className="img-responsive"
													/>
												</div>
											</div>
											<div className="blog-det">
												<h3 className="blog-title">
													<Link
														to={
															nws &&
															nws.node &&
															nws.node.slug &&
															nws.node.slug.current
														}
													>
														{nws.node.title}
													</Link>
												</h3>
												<div className="published">
													<p className="info">
														<i className="fa fa-bookmark-o" /> <i>By</i>{' '}
														<b>{nws.node.author.name}</b> |{' '}
														<i className="fa fa-clock-o" /> Created on{' '}
														<b>
															{moment(nws.node.publishedAt).format(
																'MMMM d, YYYY '
															)}
														</b>
													</p>
												</div>
												<div className="short-desc">
													<p>{nws.node.excerpt}</p>
													<p className="read-more">
														<Link
															to={
																nws &&
																nws.node &&
																nws.node.slug &&
																nws.node.slug.current
															}
														>
															Read More
															<i
																aria-hidden="true"
																className="fa fa-long-arrow-right"
															/>
														</Link>
													</p>
												</div>
											</div>
										</div>
									))}

									<nav>
										<ul className="pager">
											<li className="previous disabled  d-inline">
												<NavLink
													test={first}
													url={'latest-news/' + previousUrl}
													text="← Prev"
												/>
											</li>
											<li className="next float-right d-inline">
												<NavLink
													test={last}
													url={'latest-news/' + nextUrl}
													text="Next →"
												/>
											</li>
										</ul>
									</nav>
								</div>
							</div>
							<div className="col-md-4 right-list pull-right">
								<div id="rightside-more-blog">
									<div className="more-ttle-head">
										<h3 className="ttle-post">More News</h3>
									</div>
									{sidelist.map(list => (
										<div className="moreblog">
											<div className="row">
												<div className="col-md-5 left-more">
													<div className="lead-image">
														<img
															src={
																list &&
																list.node &&
																list.node.mainImage &&
																list.node.mainImage.asset &&
																list.node.mainImage.asset.fluid &&
																list.node.mainImage.asset.fluid.src
															}
															className="img-responsive"
															alt="Latest News"
														/>
													</div>
												</div>
												<div className="col-md-7 right-more">
													<h3 className="moreblog-title">
														<Link
															to={
																list &&
																list.node &&
																list.node.slug &&
																list.node.slug.current
															}
														>
															{list.node.title}
														</Link>
													</h3>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Layout>
		)
	}
}
export default AllNews

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}
		allSanityNews(limit: 6) {
			edges {
				node {
					id
					title
					publishedAt
					author {
						id
						name
					}
					slug {
						current
					}
					excerpt
					mainImage {
						asset {
							fluid {
								src
							}
						}
					}
				}
			}
		}
	}
`
